import "./publications-cards.scss";

import ImageLayer from "@frontend/js/Components/Shared/ImageLayer/ImageLayer";
import { resolvePreferredLocale } from "@frontend/js/utils/locale";
import DefaultImage from "@frontend/images/DefaultImage";
import { Link, usePage } from "@inertiajs/react";

export function formatPublishedAt(publishedAt, locale = "") {
    const date = new Date(publishedAt);

    if (Number.isNaN(date.getTime())) {
        return "";
    }

    const day = date.getDate();
    const month = new Intl.DateTimeFormat(locale || undefined, {
        month: "short",
    }).format(date);
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
}

export default function PublicationsCards({
    cards = [],
    limit = null,
    locale = null,
    className = "",
    cardClassName = "blogCards__card",
}) {
    const { props, url } = usePage();
    const currentLocale = resolvePreferredLocale({
        url,
        currentLocale: props?.currentLocale,
        siteLanguages: props?.siteLanguages,
    });
    const visibleCards =
        Number.isInteger(limit) && limit > 0
            ? (cards?.data || cards || []).slice(0, limit)
            : cards?.data || cards || [];

    const rootClassName = ["blogCards", className].filter(Boolean).join(" ");

    return (
        <div className={rootClassName}>
            {visibleCards.map((card) => (
                <Link key={card.id} className={cardClassName} href={card.href}>
                    <div className={`${cardClassName}__inner`}>
                        <div className={`${cardClassName}__inner__meta`}>
                            <span>
                                {formatPublishedAt(
                                    card.publishedAt,
                                    currentLocale,
                                )}
                            </span>
                            <span>
                                {card.readingMinutes?.[locale] ||
                                    card.readingMinutes}
                            </span>
                        </div>
                        <ImageLayer>
                            {card?.image ? (
                                <img
                                    className={`${cardClassName}__inner__image`}
                                    src={card.image}
                                    alt={card.title?.[locale] || card.title}
                                    loading="lazy"
                                />
                            ) : (
                                <div
                                    className={`${cardClassName}__inner__imageFallback`}
                                    aria-hidden="true"
                                >
                                    <DefaultImage />
                                </div>
                            )}
                        </ImageLayer>

                        <h3 className={`${cardClassName}__title`}>
                            {card.title?.[locale] || card.title}
                        </h3>
                        <p className={`${cardClassName}__excerpt`}>
                            {card.excerpt?.[locale] || card.excerpt}
                        </p>
                    </div>
                </Link>
            ))}{" "}
        </div>
    );
}
